import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectInstructorsContacts } from '../../store/_features/contacts/contacts.selector';
import { ContactsActions } from '../../store/_features/contacts/contacts.actions';
import { InstructorItem } from 'src/app/components/user-dashboard/contacts/models/contacts';
import { filter } from 'rxjs';
import { getSelectedIds, mapIdsToObjects } from '../../utils/ui/selector-value-adapter';

@Component({
  selector: 'app-instructor-selector',
  templateUrl: './instructor-selector.component.html',
  styleUrls: ['./instructor-selector.component.css'],
})
export class InstructorSelectorComponent implements OnInit {
  @Input() selectDefaultInstructor = false;

  @Input() set currentValue(val: InstructorItem | InstructorItem[] | number | number[] | null) {
    this._currentValue = val;
    this.updateSelectedIds();
  }
  get currentValue() {
    return this._currentValue;
  }
  private _currentValue: InstructorItem | InstructorItem[] | number | number[] | null = null;

  @Input() placeholder = 'Select Instructor';

  @Input() set multiple(value: boolean) {
    this._multiple = value;
    this.placeholder = value ? 'Select Instructor(s)' : 'Select Instructor';
  }
  get multiple(): boolean {
    return this._multiple;
  }
  private _multiple = false;

  @Output() valueChange = new EventEmitter<InstructorItem | InstructorItem[]>();
  @Output() idValueChange = new EventEmitter<number | number[]>()
  instructorsList: InstructorItem[] = [];
  selectedId: number | null = null;      // single mode
selectedIds: number[] = [];            // multiple mode


  constructor(private store: Store) {}

  ngOnInit() {
    this.store.dispatch(ContactsActions.load());

    this.store.select(selectInstructorsContacts)
      .pipe(filter(list => !!list?.length))
      .subscribe(list => {
        this.instructorsList = list;
        this.updateSelectedIds();

        if (this.selectDefaultInstructor) {
          this.onSelectValue(this.multiple ? [this.instructorsList[0].id] : this.instructorsList[0].id);
        }
      });
  }

private updateSelectedIds() {
  if (!this.instructorsList?.length) return;

  const ids = getSelectedIds(this._currentValue);

  if (this.multiple) {
    this.selectedIds = ids;
  } else {
    this.selectedId = ids.length ? ids[0] : null;
  }
}

onSelectValue(selected: number[] | number) {
  if (this.multiple) {
    this.selectedIds = selected as number[];
    const result = mapIdsToObjects(this.selectedIds, this.instructorsList, true);
    this.valueChange.emit(result);
    this.idValueChange.emit(this.selectedIds);
    this._currentValue = result;
  } else {
    this.selectedId = selected as number;
    
    const result = this.instructorsList.find(i => i.id === this.selectedId) ?? null;

    this.valueChange.emit(result);
    this.idValueChange.emit(this.selectedId);
    this._currentValue = result;
  }
}


}
